import { render, staticRenderFns } from "./bullsBreedwiseSemenCollection.vue?vue&type=template&id=1e307b6a&scoped=true&"
import script from "./bullsBreedwiseSemenCollection.vue?vue&type=script&lang=js&"
export * from "./bullsBreedwiseSemenCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e307b6a",
  null
  
)

export default component.exports